import { usePageMetadata } from '../hooks/usePageMetadata'

export default function PrivacyPolicy() {
  usePageMetadata({
    title: 'Privacy Policy | Places in Time',
    description:
      'Read how Places in Time handles personal data, cookies, account information, and GDPR rights across the site and chat experience.',
    path: '/privacy-policy-gdpr',
  })

  return (
    <main className="page legal-page">
      <section className="page-hero">
        <h1>Privacy Policy &amp; GDPR</h1>
        <p>
          We collect only the information required to run Places in Time, keep accounts secure, and understand how the
          atlas is being used. This overview explains what data we store, why we store it, and how you can exercise your
          rights under GDPR and related regulations.
        </p>
      </section>

      <section className="page-section">
        <h2>Data we collect</h2>
        <p>
          When you create an account or sign up for updates we store your name, email, and any profile settings you
          provide. Usage analytics are captured in aggregate to show us which pages resonate and which conversations need
          more training. If you submit content or feedback, we log the text plus the timestamp so we can follow up.
        </p>
      </section>

      <section className="page-section">
        <h2>How we use the data</h2>
        <p>
          Personal information allows us to authenticate you, respond to support questions, and send operational messages.
          Aggregate analytics help us prioritize new figures, places, and interface improvements. We never sell data to
          third parties, and any vendor processing information on our behalf must comply with GDPR terms.
        </p>
      </section>

      <section className="page-section">
        <h2>Cookies and storage</h2>
        <p>
          Places in Time uses essential cookies and secure storage to keep you signed in and remember interface
          preferences. Optional analytics cookies are only enabled with consent and can be disabled at any time through
          your browser controls.
        </p>
      </section>

      <section className="page-section">
        <h2>Your rights</h2>
        <p>
          You may request a copy of your data, ask us to correct or delete information, or restrict certain processing
          activities. Email privacy@places-in-time.com with your request and we will respond within 30 days. If you are
          not satisfied with our response you have the right to contact your local data protection authority.
        </p>
      </section>

      <section className="page-section">
        <h2>Contact</h2>
        <p>
          Reach us at privacy@places-in-time.com for any privacy question. We will update this policy whenever our data
          practices change and will note the revision date clearly on this page.
        </p>
      </section>
    </main>
  )
}
